import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "repayment-page" }
const _hoisted_2 = { class: "repayment-card" }
const _hoisted_3 = { class: "repayment-list" }
const _hoisted_4 = { class: "repayment-row" }
const _hoisted_5 = { class: "repayment-value-group" }
const _hoisted_6 = { class: "repayment-value" }
const _hoisted_7 = { class: "repayment-row" }
const _hoisted_8 = { class: "repayment-value-group" }
const _hoisted_9 = { class: "repayment-value" }
const _hoisted_10 = { class: "repayment-row repayment-row-note" }
const _hoisted_11 = { class: "repayment-value-group" }
const _hoisted_12 = { class: "repayment-value" }
const _hoisted_13 = { class: "repayment-row" }
const _hoisted_14 = { class: "repayment-value repayment-value-amount" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[8] || (_cache[8] = _createElementVNode("h1", { class: "repayment-title" }, "Informacion de pago", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "repayment-label" }, "Banco de pago", -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.receiptNameValue), 1),
            (_ctx.receiptNameValue !== _ctx.placeholder)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "repayment-copy",
                  type: "button",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleCopy(_ctx.receiptNameValue)))
                }, " copiar "))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "repayment-label" }, "IBAN", -1)),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.receiptAccountValue), 1),
            (_ctx.receiptAccountValue !== _ctx.placeholder)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "repayment-copy",
                  type: "button",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleCopy(_ctx.receiptAccountValue)))
                }, " copiar "))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "repayment-label" }, "Observaciones", -1)),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.conceptValue), 1),
            (_ctx.conceptValue !== _ctx.placeholder)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "repayment-copy",
                  type: "button",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleCopy(_ctx.conceptValue)))
                }, " copiar "))
              : _createCommentVNode("", true)
          ]),
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "repayment-hint" }, " La referencia debe rellenarse según lo indicado y debe seleccionar la transferencia inmediata. De lo contrario, el pago podría no abonarse correctamente. ", -1))
        ]),
        _createElementVNode("div", _hoisted_13, [
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "repayment-label" }, "Importe", -1)),
          _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.repayAmountValue), 1)
        ])
      ])
    ])
  ]))
}